<template>
    <div class="modal fade" id="order_accept_modal" tabindex="-1" role="dialog" aria-labelledby="complaintModal">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <h4 class="modal-title" id="myModalLabel">Accept Order</h4>
                </div>
                <form class="form-horizontal" @submit.prevent="acceptOrder()">
                    <div class="modal-body">
                        <div class="form-group">
                            <div class="row">
                                <div class="col-lg-6">
                                    <label>How much it will take?</label>
                                </div>
                                <div class="col-lg-6">
                                    <input @input="timeButtonSelected" type="number" min="0" v-model="timeRequired" placeholder="Priority" class="form-control" />
                                </div>
                            </div>
                            <div class="row m-t-lg">
                                <div class="col-md-2 text-center">
                                    <button @click="timeButtonSelected(20)" type="button" class="btn time-btns btn-info time-20">20 min</button>
                                </div>
                                <div class="col-md-2 text-center">
                                    <button @click="timeButtonSelected(30)" type="button" class="btn time-btns btn-light time-30">30 min</button>
                                </div>
                                <div class="col-md-2 text-center">
                                    <button @click="timeButtonSelected(40)" type="button" class="btn time-btns btn-info time-40">40 min</button>
                                </div>
                                <div class="col-md-2 text-center">
                                    <button @click="timeButtonSelected(50)" type="button" class="btn time-btns btn-info time-50">50 min</button>
                                </div>
                                <div class="col-md-2 text-center">
                                    <button @click="timeButtonSelected(60)" type="button" class="btn time-btns btn-info time-60">60 min</button>
                                </div>
                                <div class="col-md-2 text-center">
                                    <button @click="timeButtonSelected(70)" type="button" class="btn time-btns btn-info time-70">70 min</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" @click="closeModal">Close</button>
                        <button type="submit" v-bind:disabled="saveButtonDisable" v-bind:class="'btn btn-success ld-over ld-ext-right ' + submitBtlLoaderClass">Accept<i class="ld ld-ring ld-spin"></i></button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "OrderAcceptModal",
    props: {
        order: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            submitBtlLoaderClass: "",
            saveButtonDisable: false,
            timeRequired: 30,
        }
    },
    methods: {
        async acceptOrder() {
            this.submitBtlLoaderClass = "running";
            this.saveButtonDisable = true
            const payload = new URLSearchParams({
                order_id: this.order.id,
                status_id: this.$status.ACCEPTED_BY_BRANCH.id,
                expected_delivery_minutes: this.timeRequired
            });
            this.$emit('acceptOrder', payload)
            await this.$store.dispatch('stopNotificationBell');
            // eslint-disable-next-line no-undef
            $("#order_accept_modal").modal("hide");
            // eslint-disable-next-line no-undef
            $("#branch_order_view_model").modal("hide");
            this.saveButtonDisable = false;
            this.submitBtlLoaderClass = "";
        },
        timeButtonSelected(timeRequired) {
            // eslint-disable-next-line no-undef
            $('.time-btns').removeClass('btn-light').addClass('btn-info');
            if(typeof timeRequired === 'number') {
                this.timeRequired = timeRequired
            }
            // eslint-disable-next-line no-undef
            $('.time-' + this.timeRequired).removeClass('btn-info').addClass('btn-light');
        },
        closeModal() {
            // eslint-disable-next-line no-undef
            $("#order_accept_modal").modal("hide");
        }
    }
}
</script>

<style scoped>

</style>
